
import request from '@/utils/request';

export const getRepairWorkbench = (params: any) =>
  request({
    url: 'Dashboard/repairWorkbench',
    method: 'get',
    params
  });
export const getServiceWorkbench = (params: any) =>
  request({
    url: 'Dashboard/serviceWorkbench',
    method: 'get',
    params
  });
